<template>
  <div id="app" class="size-full">
    <div class="size-full flex flex-col">
      <router-view class="flex-1"/>
      <footer class="flex items-center py-2 px-4 justify-center">
        <span class="">备案号：</span><a href="https://beian.miit.gov.cn/" target="_blank">新ICP备2024009053号-1</a>
      </footer>
    </div>
  </div>
</template>

<script>
  export default {
    data(){
      return {
        visible: true,
      }
    },
    methods:{
      animate(){
        const endTime = new Date('2024/07/01 00:00:00').getTime();
        const now = new Date().getTime()
        if(now >= endTime){
          this.visible = false;
        }
        requestAnimationFrame(this.animate);
      }
    },
    created(){
      
    },
  }
</script>

<style lang="less"></style>
